import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['runningName']

  connect() {
    let thisController = this
    let classification_names = JSON.parse(this.data.get('classification-names'))
    thisController.runningNameTarget.innerHTML = classification_names[0]
    let counter = 1
    
    setInterval(function() {
      thisController.runningNameTarget.innerHTML = classification_names[counter]
      counter < classification_names.length - 1 ? counter++ : counter = 0
    }, 5000)
  }
}
